import { lazy, Suspense } from "react";
import { Button, Col, Flex, Row } from "antd";
import Layout from "../components/layout";
import HeroScreen from "../components/HeroScreenV2/heroScreen";
import classes from "../components/HeroScreen/heroScreen.module.css";
import { useNav } from "../hooks/useNav";
import Doctors from "../components/doctors/doctors";
import Container from "../components/container";

const HowItWorks = lazy(() => import("../components/Screens/howItWorks"));
const GreySection = lazy(() => import("../components/Screens/greySection"));
const AdvantagesScreen = lazy(() => import("../components/Screens/advantages"));

const Landing = () => {
  const { navSurvey, navExperts, navProfessionals } = useNav();

  return (
    <Layout>
      <HeroScreen imgSrc="/landing/home/hero-iphone.png">
        <h1 className="heroTitle">In ascolto, in aiuto</h1>
        <Flex
          vertical
          gap={16}
          className={`${classes.text} text-sm max-w-[515px]`}
        >
          <p>
            In Buona Salute, il tuo punto di riferimento per il supporto psiconcologico.
            Se stai visitando il nostro sito in cerca di aiuto e supporto, sei nel posto giusto.
          </p>
          <p>
            <strong>Siamo qui per te in ogni fase del tuo percorso di malattia.</strong>
          </p>
        </Flex>
        <div className="bg-[rgba(109,109,109,0.16)] p-4 xl_p-[45px] rounded-[16px]">
          <Row gutter={[54, 24]}>
            <Col span={24} lg={12}>
              <span className="text-center mb-2 block text-base">La prima consulenza è <strong>gratuita!</strong></span>
              <Button onClick={() => navExperts()} type="primary" size="large" block className="text-[24px] xl_text-[30px] md_h-[62px]">Prenota la tua visita</Button>
            </Col>
            <Col span={24} lg={12}>
              <span className="text-center mb-2 block text-base">Vuoi un supporto <strong>personalizzato?</strong></span>
              <Button onClick={() => navSurvey()} size="large" block className="text-[24px] xl_text-[30px] md_h-[62px]">Inizia questionario</Button>
            </Col>
          </Row>
        </div>
      </HeroScreen>
      <Suspense>
        <HowItWorks/>
      </Suspense>
      <Suspense>
        <div className=" py-[3rem]">
          <Container>
            <h2 className="heading text-center">
              Il nostri Psiconcologi
            </h2>
            <Doctors/>
            <Flex justify="center" gap={12} className="mt-[40px]">
              <Button
                onClick={navProfessionals}
                size="large"
                className="wideButton"
              >
                Guardali tutti
              </Button>
              <Button
                onClick={navExperts}
                size="large"
                type="primary"
                className="wideButton"
              >
                Prenota la tua visita
              </Button>
            </Flex>
          </Container>
        </div>
      </Suspense>
      <Suspense>
        <GreySection title="La nostra tecnologia">
          <Flex
            vertical
            justify="center"
            className="desktop_h-[36vw]"
          >
            <Flex vertical gap={20} className="text-xl py-32" align="start">
              <Flex align="center" gap={12}>
                <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
                  <path d="M8.75065 14.0002L12.2507 17.5002L19.2507 10.5002M25.6673 14.0002C25.6673 20.4435 20.444 25.6668 14.0007 25.6668C7.55733 25.6668 2.33398 20.4435 2.33398 14.0002C2.33398 7.55684 7.55733 2.3335 14.0007 2.3335C20.444 2.3335 25.6673 7.55684 25.6673 14.0002Z" stroke="#204480" strokeWidth="2.33333" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
                <span>
                  Supporto psiconcologico personalizzato
                </span>
              </Flex>
              <Flex align="center" gap={12}>
                <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
                  <path d="M8.75065 14.0002L12.2507 17.5002L19.2507 10.5002M25.6673 14.0002C25.6673 20.4435 20.444 25.6668 14.0007 25.6668C7.55733 25.6668 2.33398 20.4435 2.33398 14.0002C2.33398 7.55684 7.55733 2.3335 14.0007 2.3335C20.444 2.3335 25.6673 7.55684 25.6673 14.0002Z" stroke="#204480" strokeWidth="2.33333" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
                <span>
                  Accesso 24 ore 7 giorni alla settimana
                </span>
              </Flex>
              <Flex align="center" gap={12}>
                <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
                  <path d="M8.75065 14.0002L12.2507 17.5002L19.2507 10.5002M25.6673 14.0002C25.6673 20.4435 20.444 25.6668 14.0007 25.6668C7.55733 25.6668 2.33398 20.4435 2.33398 14.0002C2.33398 7.55684 7.55733 2.3335 14.0007 2.3335C20.444 2.3335 25.6673 7.55684 25.6673 14.0002Z" stroke="#204480" strokeWidth="2.33333" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
                <span>
                  Altissima specializzazione dei nostri professionisti
                </span>
              </Flex>
              <Button
                onClick={navExperts}
                size="large"
                className="wideButton"
                type="primary"
              >
                Prenota la tua visita
              </Button>
              <Button
                onClick={navSurvey}
                size="large"
                className="wideButton"
              >
                Inizia questionario
              </Button>
            </Flex>
            <img
              src="/landing/home/hero-desk.png"
              alt="desk"
              className="relative desktop_absolute desktop_w-[54%] -right-[32px] bottom-0 desktop_right-0"
            />
          </Flex>
        </GreySection>
      </Suspense>
      <Suspense>
        <AdvantagesScreen hasGrayBackground={false} />
      </Suspense>
    </Layout>
  );
};

export default Landing;
